import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "O projekcie", href: "#o-projekcie" },
  { label: "Kategorie", href: "#kategorie" },
  { label: "Materiały", href: "#materialy" },
  { label: "Dlaczego warto", href: "#dlaczego" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-beige/85 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="w-full max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" onClick={(e) => scrollTo(e, "#top")} className="flex items-center gap-2.5 group" data-testid="navbar-brand">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-forest text-gold font-outfit text-lg font-semibold">⟁</span>
          <span className="font-outfit text-lg font-semibold tracking-tight text-ink">Złap Kod Natury</span>
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              className="font-manrope text-sm text-ink-soft hover:text-forest transition-colors duration-200"
              data-testid={`navbar-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#materialy"
          onClick={(e) => scrollTo(e, "#materialy")}
          className="hidden sm:inline-flex items-center bg-forest text-beige px-5 py-2.5 rounded-2xl font-outfit text-sm tracking-wide hover:bg-forest-hover shadow-clay hover:shadow-clay-lg transition-all duration-300"
          data-testid="navbar-cta"
        >
          Odbierz darmowe materiały
        </a>
      </nav>
    </motion.header>
  );
}
